import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaTools, FaBriefcase, FaWhatsapp, FaTimes } from 'react-icons/fa';
import styles from './Navbar.module.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.style.overflow = isOpen ? 'auto' : 'hidden';
  };

  return (
    <>
      <nav className={styles.navbar}>
        <div className={styles.logoSection}>
          <Link to="/" className={styles.logo}>
            LUCQA
          </Link>
        </div>

        <div className={styles.menuSection}>
          <Link to="/" className={styles.menuItem}>
            <div className={styles.iconWrapper}>
              <FaHome />
            </div>
            <span>Inicio</span>
          </Link>
          <Link to="/servicios" className={styles.menuItem}>
            <div className={styles.iconWrapper}>
              <FaTools />
            </div>
            <span>Servicios</span>
          </Link>
          <Link to="/trabajos" className={styles.menuItem}>
            <div className={styles.iconWrapper}>
              <FaBriefcase />
            </div>
            <span>Portafolio</span>
          </Link>
        </div>

        <div className={styles.ctaSection}>
          <button className={styles.ctaButton}>
            <FaWhatsapp className={styles.ctaIcon} />
            <span>Contactar</span>
          </button>
        </div>

        <button className={`${styles.hamburger} ${isOpen ? styles.active : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      {isOpen && <div className={styles.overlay} onClick={toggleMenu}></div>}
      <div className={`${styles.mobileMenu} ${isOpen ? styles.active : ''}`}>
        <div className={styles.menuHeader}>
          <h3>Menú</h3>
          <button className={styles.closeButton} onClick={toggleMenu}>
            <FaTimes />
          </button>
        </div>
        
        <div className={styles.menuContent}>
          <Link to="/" className={styles.mobileMenuItem} onClick={toggleMenu}>
            <FaHome className={styles.icon} />
            <span>Inicio</span>
          </Link>
          <Link to="/servicios" className={styles.mobileMenuItem} onClick={toggleMenu}>
            <FaTools className={styles.icon} />
            <span>Servicios</span>
          </Link>
          <Link to="/trabajos" className={styles.mobileMenuItem} onClick={toggleMenu}>
            <FaBriefcase className={styles.icon} />
            <span>Portafolio</span>
          </Link>
        </div>

        <div className={styles.mobileCta}>
          <button className={styles.ctaButton}>
            <FaWhatsapp className={styles.ctaIcon} />
            <span>Contactar</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Navbar;